import CountryList from "../../slices/user_management/country/CountryList";
import CountryDetails from "../../slices/user_management/country/CountryDetails";
import StateList from "../../slices/user_management/state/StateList";
import StateDetails from "../../slices/user_management/state/StateDetails";
import StatebyCountry from "../../slices/user_management/state/StatebyCountry";
import CityList from "../../slices/user_management/city/CityList";
import CityDetails from "../../slices/user_management/city/CityDetails";
import CitybyState from "../../slices/user_management/city/CitybyState";
import CompanyList from "../../slices/user_management/company/CompanyList";
import CompanyDetails from "../../slices/user_management/company/CompanyDetails";
import CompanyBusinessAreaList from "../../slices/user_management/company_business_area/CompanyBusinessAreaList";
import CompanyBusinessAreaDetails from "../../slices/user_management/company_business_area/CompanyBusinessAreaDetails";
import WareHouseList from "../../slices/user_management/business_area_ware_house/WareHouseList";
import WareHouseDetails from "../../slices/user_management/business_area_ware_house/WareHouseDetails";
import MenuList from "../../slices/user_management/menu/MenuList";
import MenuDetails from "../../slices/user_management/menu/MenuDetails";
import SubMenuList from "../../slices/user_management/sub_menu/SubMenuList";
import SubMenuDetails from "../../slices/user_management/sub_menu/SubMenuDetails";
import SubMenuByMenu from "../../slices/user_management/sub_menu/SubMenuByMenu";
import PermissionMenuList from "../../slices/user_management/permission_menu/PermissionMenuList";
import PermissionMenuDetails from "../../slices/user_management/permission_menu/PermissionMenuDetails";
import RoleList from "../../slices/user_management/role/RoleList";
import RoleDetails from "../../slices/user_management/role/RoleDetails";
import UserRoleList from "../../slices/user_management/user_role/UserRoleList";
import UserRoleDetails from "../../slices/user_management/user_role/UserRoleDetails";
import RolePermissionByRole from "../../slices/user_management/role_permission/RolePermissionByRole";
import TaxTypeList from "../../slices/user_management/tax_type/TaxTypeList";
import TaxTypeDetails from "../../slices/user_management/tax_type/TaxTypeDetails";
import TaxList from "../../slices/user_management/tax/TaxList";
import TaxDetails from "../../slices/user_management/tax/TaxDetails";
import CostCenterList from "../../slices/user_management/cost_center/CostCenterList";
import CostCenterDetails from "../../slices/user_management/cost_center/CostCenterDetails";
import CurrencyList from "../../slices/user_management/currency/CurrencyList";
import CurrencyDetails from "../../slices/user_management/currency/CurrencyDetails";

const userManagementReducer = {
    countryList: CountryList,
    countryDetails: CountryDetails,
    stateList: StateList,
    stateDetails: StateDetails,
    statebyCountry: StatebyCountry,
    cityList: CityList,
    cityDetails: CityDetails,
    citybyState: CitybyState,
    companyList: CompanyList,
    companyDetails: CompanyDetails,
    companyBusinessAreaList: CompanyBusinessAreaList,
    companyBusinessAreaDetails: CompanyBusinessAreaDetails,
    wareHouseList: WareHouseList,
    wareHouseDetails: WareHouseDetails,
    menuList: MenuList,
    menuDetails: MenuDetails,
    subMenuList: SubMenuList,
    subMenuDetails: SubMenuDetails,
    subMenubyMenu: SubMenuByMenu,
    permissionMenuList: PermissionMenuList,
    permissionMenuDetails: PermissionMenuDetails,
    roleList: RoleList,
    roleDetails: RoleDetails,
    userRoleList: UserRoleList,
    userRoleDetails: UserRoleDetails,
    rolePermisssionByRole: RolePermissionByRole,
    taxTypeList: TaxTypeList,
    taxTypeDetails: TaxTypeDetails,
    taxList: TaxList,
    taxDetails: TaxDetails,
    costCenterList: CostCenterList,
    costCenterDetails: CostCenterDetails,
    currencyList: CurrencyList,
    currencyDetails: CurrencyDetails,
};

export default userManagementReducer;